module.exports = __webpack_public_path__ + "img/70.85051f17.webp";